export const FOCUS_ROUTE_THRESHOLD = 10;
export const MAX_FOCUSED_ROUTES = 6;

export function needsRouteFocus(routeCount: number) {
  return routeCount > FOCUS_ROUTE_THRESHOLD;
}

export function sanitizeFocusedRouteIds(
  ids: string[] | null,
  availableRouteIds: string[],
  max = MAX_FOCUSED_ROUTES,
): string[] | null {
  if (ids == null) return null;
  const available = new Set(availableRouteIds);
  const next = ids.filter((id) => available.has(id)).slice(0, max);
  return next.length > 0 ? next : null;
}
